import myAxios from "@/services/api";

export const API_MESSAGES = {
  DEFAULT: "Tente novamente. Se a situação persistir, contacte o suporte!",
  NOT_FOUND: "Recurso não encontrado.",
  API_FAIL: "Falha de conexão. Se persistir, contacte o suporte!",
  API_SUCCESS: "ok",
};

export async function callAPI(url, payload) {
  try {
    const response = await myAxios.post(url, payload);
    if (response.data?.state !== API_MESSAGES.API_SUCCESS) {
      throw new Error(
        "Utilizador não possui acesso à aplicação GEOOPS"
      );
    }
    return response.data.data;
  } catch (error) {
    console.error(error.message || API_MESSAGES.DEFAULT);
    throw error;
  }
}